/* DASI — Fond des blocs « un sur deux » (alterné).
   Pose la classe .dasi-block-colored sur un bloc produit custom VISIBLE sur deux,
   en ordre d'affichage. Gère l'auto-masquage : seuls les blocs réellement visibles
   sont comptés (un bloc masqué ne décale pas l'alternance). Le CSS (dasi-color-vars)
   colore .dasi-block-colored avec la couleur de la gamme.
   Chargé uniquement si le réglage « un sur deux » est activé (cf. layout/theme.liquid). */
(function () {
  'use strict';
  var SEL = [
    '.anecdote-section', '.fiche-infusion-section', '.certifications-section',
    '.specialite-cafe-section', '.aroma-bars-section', '.origin-map-section',
    '.ingredients-section', '.couleur-the-section', '.conseil-avis-section',
    '.info-blocks-section', '.assortiment-section'
  ].join(',');

  function apply() {
    var all = document.querySelectorAll(SEL);
    var rank = 0;
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var visible = el.offsetParent !== null && el.getBoundingClientRect().height > 4;
      if (!visible) { el.classList.remove('dasi-block-colored'); continue; }
      if (rank % 2 === 0) el.classList.add('dasi-block-colored');
      else el.classList.remove('dasi-block-colored');
      rank++;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  // Recalcule si la fenêtre change (un bloc peut passer visible/masqué selon le layout).
  window.addEventListener('load', apply);
})();
